import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import MiniAngelScene from './MiniAngelScene';

export default function FooterSection() {
  return (
    <footer className="relative overflow-hidden pt-32 pb-12" data-testid="footer-section">
      <div className="section-divider mb-24" />
      <div className="hidden lg:block absolute top-16 right-20 z-0"><MiniAngelScene type="halo" size={180} /></div>
      <div className="hidden lg:block absolute bottom-32 left-12 z-0"><MiniAngelScene type="feather" size={130} /></div>
      
      {/* Massive Typography */}
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.5 }}
        >
          <h2 className="font-heading text-[12vw] leading-[0.85] text-white/[0.03] select-none">
            ARCHANGEL
          </h2>
        </motion.div>

        {/* Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-16 pt-12 border-t border-white/5">
          <div>
            <p className="font-heading text-sm tracking-widest mb-4">ARCHANGELWORKS</p>
            <p className="text-white/30 text-sm leading-relaxed">
              AI-Powered 3D Agency.
              <br />
              Building celestial creations.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs tracking-[0.2em] text-white/30 uppercase mb-4">Links</p>
            <div className="space-y-3">
              {['Services', 'Portfolio', 'About', 'Contact'].map((link) => (
                <a
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  className="block text-white/40 hover:text-white text-sm transition-colors duration-300 group"
                >
                  {link}
                  <ArrowUpRight size={12} className="inline ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono text-xs tracking-[0.2em] text-white/30 uppercase mb-4">Connect</p>
            <div className="space-y-3">
              {[
                { label: 'Instagram', url: 'https://www.instagram.com/archangel.works/' },
                { label: 'TikTok', url: 'https://www.tiktok.com/@archangelworks0?_r=1&_t=ZN-954MtsiTpUk' },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  className="block text-white/40 hover:text-white text-sm transition-colors duration-300 group"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {social.label}
                  <ArrowUpRight size={12} className="inline ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between mt-16 pt-8 border-t border-white/5">
          <p className="font-mono text-xs text-white/20">
            {new Date().getFullYear()} ARCHANGELWORKS. ALL RIGHTS RESERVED.
          </p>
          <p className="font-mono text-xs text-white/10 mt-2 md:mt-0">
            CELESTIAL CREATIONS
          </p>
        </div>
      </div>
    </footer>
  );
}
